import { cn } from "@/lib/utils";

/**
 * Endless horizontal (or vertical) scroller, adapted from the shadcn-space
 * Marquee for this JS + Tailwind 3 project. Keyframes live in src/index.css.
 *
 * Props:
 *  - reverse:      run the other way
 *  - pauseOnHover: stop while the pointer is over it
 *  - vertical:     scroll up instead of sideways
 *  - repeat:       how often the content is repeated (default 4)
 */
export function Marquee({
  className,
  reverse = false,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  ...props
}) {
  return (
    <div
      {...props}
      className={cn(
        "group flex gap-[var(--gap)] overflow-hidden p-2 [--duration:40s] [--gap:1rem]",
        {
          "flex-row": !vertical,
          "flex-col": vertical,
          "pause-on-hover": pauseOnHover,
        },
        className,
      )}
    >
      {Array(repeat)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            // Only the first copy is read out by screen readers.
            aria-hidden={i > 0 || undefined}
            className={cn("flex shrink-0 justify-around gap-[var(--gap)]", {
              "animate-marquee flex-row": !vertical,
              "animate-marquee-vertical flex-col": vertical,
              "animate-reverse": reverse,
            })}
          >
            {children}
          </div>
        ))}
    </div>
  );
}
